module.exports = __webpack_public_path__ + "media/site/images/technologies/swift-icon-8890d29b2ea138bf8434443ecad60fd9.svg";